// AUTO-GENERATED SEED — review before trusting. Rename keys (index→list/detail),
// refine params, confirm caller flags, add opt-in response types.
// BL-1969: the transactions / refund / client-error routes were deleted with
// the old payments back office; only the Finix webhook (card holds + merchant
// status) remains.
import { defineAdminRoute } from './define-admin-route';

export const payments = {
  webhook: {
    finix: defineAdminRoute({
        path: '/api/payments/webhook/finix',
        params: {},
        // Declared, not bound (BL-1833 PR 4a): Finix sends no staff session.
        methods: {
          POST: {
            grant: { none: 'webhook — the Finix HMAC signature (FINIX_WEBHOOK_SECRET) authorizes it' },
            tenant: { from: 'none', reason: 'webhook — the tenant is found from the merchant id after verification' },
          },
        },
        caller: 'webhook',
      }),
  },
};
